import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from '../Util.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { asUtf8ToByteArray29u89fcaeh9ki as asUtf8ToByteArray } from '../NonJvmPlatform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HEX_DIGIT_BYTES;
var DigitCountToLargestValue;
function commonIndexOf(_this__u8e3s4, bytes, fromIndex, toIndex, bytesOffset, byteCount) {
  toIndex = toIndex === VOID ? 9223372036854775807n : toIndex;
  bytesOffset = bytesOffset === VOID ? 0 : bytesOffset;
  byteCount = byteCount === VOID ? bytes.get_size_woubt6_k$() : byteCount;
  _init_properties_Buffer_kt__ndcom8();
  checkOffsetAndCount(fromInt(bytes.get_size_woubt6_k$()), fromInt(bytesOffset), fromInt(byteCount));
  // Inline function 'kotlin.require' call
  if (!(byteCount > 0)) {
    var message = 'byteCount == 0';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(fromIndex >= 0n)) {
    var message_0 = 'fromIndex < 0: ' + fromIndex.toString();
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message_1 = 'fromIndex > toIndex: ' + fromIndex.toString() + ' > ' + toIndex.toString();
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
  }
  var fromIndex_0 = fromIndex;
  var toIndex_0 = toIndex;
  if (toIndex_0 > _this__u8e3s4.size_1)
    toIndex_0 = _this__u8e3s4.size_1;
  if (fromIndex_0 === toIndex_0)
    return -1n;
  var tmp2 = fromIndex_0;
  $l$block_1: {
    // Inline function 'okio.internal.seek' call
    var tmp0_elvis_lhs = _this__u8e3s4.head_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (null == null) {
        return -1n;
      } else {
        tmp_0 = null;
      }
      var s = tmp_0;
      var offset = -1n;
      var targetByteArray = bytes.internalArray_nlkee4_k$();
      var b0 = targetByteArray[bytesOffset];
      var tmp0 = toIndex_0;
      // Inline function 'kotlin.Long.minus' call
      var this_0 = _this__u8e3s4.size_1;
      var tmp$ret$8 = subtract(this_0, fromInt(byteCount));
      // Inline function 'kotlin.comparisons.minOf' call
      var b = add(tmp$ret$8, 1n);
      var resultLimit = tmp0 <= b ? tmp0 : b;
      while (offset < resultLimit) {
        var data = s.data_1;
        var tmp0_0 = s.limit_1;
        // Inline function 'okio.minOf' call
        var b_0 = subtract(add(numberToLong(s.pos_1), resultLimit), offset);
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0_0);
        var tmp$ret$10 = a <= b_0 ? a : b_0;
        var segmentLimit = convertToInt(tmp$ret$10);
        var inductionVariable = convertToInt(subtract(add(numberToLong(s.pos_1), fromIndex_0), offset));
        if (inductionVariable < segmentLimit)
          do {
            var pos = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (data[pos] === b0 && rangeEquals(s, pos + 1 | 0, targetByteArray, bytesOffset + 1 | 0, byteCount)) {
              return add(numberToLong(pos - s.pos_1 | 0), offset);
            }
          }
           while (inductionVariable < segmentLimit);
        offset = add(offset, fromInt(s.limit_1 - s.pos_1 | 0));
        fromIndex_0 = offset;
        s = ensureNotNull(s.next_1);
      }
      return -1n;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var s_0 = tmp;
    if (subtract(_this__u8e3s4.size_1, tmp2) < tmp2) {
      var offset_0 = _this__u8e3s4.size_1;
      while (offset_0 > tmp2) {
        s_0 = ensureNotNull(s_0.prev_1);
        offset_0 = subtract(offset_0, fromInt(s_0.limit_1 - s_0.pos_1 | 0));
      }
      var tmp0_1 = s_0;
      var offset_1 = offset_0;
      var tmp_1;
      if (tmp0_1 == null) {
        return -1n;
      } else {
        tmp_1 = tmp0_1;
      }
      var s_1 = tmp_1;
      var offset_2 = offset_1;
      var targetByteArray_0 = bytes.internalArray_nlkee4_k$();
      var b0_0 = targetByteArray_0[bytesOffset];
      var tmp0_2 = toIndex_0;
      // Inline function 'kotlin.Long.minus' call
      var this_1 = _this__u8e3s4.size_1;
      var tmp$ret$13 = subtract(this_1, fromInt(byteCount));
      // Inline function 'kotlin.comparisons.minOf' call
      var b_1 = add(tmp$ret$13, 1n);
      var resultLimit_0 = tmp0_2 <= b_1 ? tmp0_2 : b_1;
      while (offset_2 < resultLimit_0) {
        var data_0 = s_1.data_1;
        var tmp0_3 = s_1.limit_1;
        // Inline function 'okio.minOf' call
        var b_2 = subtract(add(numberToLong(s_1.pos_1), resultLimit_0), offset_2);
        // Inline function 'kotlin.comparisons.minOf' call
        var a_0 = fromInt(tmp0_3);
        var tmp$ret$15 = a_0 <= b_2 ? a_0 : b_2;
        var segmentLimit_0 = convertToInt(tmp$ret$15);
        var inductionVariable_0 = convertToInt(subtract(add(numberToLong(s_1.pos_1), fromIndex_0), offset_2));
        if (inductionVariable_0 < segmentLimit_0)
          do {
            var pos_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (data_0[pos_0] === b0_0 && rangeEquals(s_1, pos_0 + 1 | 0, targetByteArray_0, bytesOffset + 1 | 0, byteCount)) {
              return add(numberToLong(pos_0 - s_1.pos_1 | 0), offset_2);
            }
          }
           while (inductionVariable_0 < segmentLimit_0);
        offset_2 = add(offset_2, fromInt(s_1.limit_1 - s_1.pos_1 | 0));
        fromIndex_0 = offset_2;
        s_1 = ensureNotNull(s_1.next_1);
      }
      return -1n;
    } else {
      var offset_3 = 0n;
      $l$loop: while (true) {
        var tmp0_4 = offset_3;
        // Inline function 'kotlin.Long.plus' call
        var other = s_0.limit_1 - s_0.pos_1 | 0;
        var nextOffset = add(tmp0_4, fromInt(other));
        if (nextOffset > tmp2)
          break $l$loop;
        s_0 = ensureNotNull(s_0.next_1);
        offset_3 = nextOffset;
      }
      var tmp0_5 = s_0;
      var offset_4 = offset_3;
      var tmp_2;
      if (tmp0_5 == null) {
        return -1n;
      } else {
        tmp_2 = tmp0_5;
      }
      var s_2 = tmp_2;
      var offset_5 = offset_4;
      var targetByteArray_1 = bytes.internalArray_nlkee4_k$();
      var b0_1 = targetByteArray_1[bytesOffset];
      var tmp0_6 = toIndex_0;
      // Inline function 'kotlin.Long.minus' call
      var this_2 = _this__u8e3s4.size_1;
      var tmp$ret$19 = subtract(this_2, fromInt(byteCount));
      // Inline function 'kotlin.comparisons.minOf' call
      var b_3 = add(tmp$ret$19, 1n);
      var resultLimit_1 = tmp0_6 <= b_3 ? tmp0_6 : b_3;
      while (offset_5 < resultLimit_1) {
        var data_1 = s_2.data_1;
        var tmp0_7 = s_2.limit_1;
        // Inline function 'okio.minOf' call
        var b_4 = subtract(add(numberToLong(s_2.pos_1), resultLimit_1), offset_5);
        // Inline function 'kotlin.comparisons.minOf' call
        var a_1 = fromInt(tmp0_7);
        var tmp$ret$21 = a_1 <= b_4 ? a_1 : b_4;
        var segmentLimit_1 = convertToInt(tmp$ret$21);
        var inductionVariable_1 = convertToInt(subtract(add(numberToLong(s_2.pos_1), fromIndex_0), offset_5));
        if (inductionVariable_1 < segmentLimit_1)
          do {
            var pos_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (data_1[pos_1] === b0_1 && rangeEquals(s_2, pos_1 + 1 | 0, targetByteArray_1, bytesOffset + 1 | 0, byteCount)) {
              return add(numberToLong(pos_1 - s_2.pos_1 | 0), offset_5);
            }
          }
           while (inductionVariable_1 < segmentLimit_1);
        offset_5 = add(offset_5, fromInt(s_2.limit_1 - s_2.pos_1 | 0));
        fromIndex_0 = offset_5;
        s_2 = ensureNotNull(s_2.next_1);
      }
      return -1n;
    }
  }
}
function readUtf8Line(_this__u8e3s4, newline) {
  _init_properties_Buffer_kt__ndcom8();
  var tmp;
  var tmp_0;
  if (newline > 0n) {
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = subtract(newline, fromInt(1));
    var tmp_1 = _this__u8e3s4.get_f9lzxq_k$(tmp$ret$0);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(13);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
    tmp_0 = tmp_1 === toByte(tmp$ret$1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var result = _this__u8e3s4.readUtf8_yzubzx_k$(subtract(newline, 1n));
    _this__u8e3s4.skip_csbv9x_k$(2n);
    tmp = result;
  } else {
    var result_0 = _this__u8e3s4.readUtf8_yzubzx_k$(newline);
    _this__u8e3s4.skip_csbv9x_k$(1n);
    tmp = result_0;
  }
  return tmp;
}
function selectPrefix(_this__u8e3s4, options, selectTruncated) {
  selectTruncated = selectTruncated === VOID ? false : selectTruncated;
  _init_properties_Buffer_kt__ndcom8();
  var tmp0_elvis_lhs = _this__u8e3s4.head_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return selectTruncated ? -2 : -1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var head = tmp;
  var s = head;
  var data = head.data_1;
  var pos = head.pos_1;
  var limit = head.limit_1;
  var trie = options.trie_1;
  var triePos = 0;
  var prefixIndex = -1;
  navigateTrie: while (true) {
    var _unary__edvuaz = triePos;
    triePos = _unary__edvuaz + 1 | 0;
    var scanOrSelect = trie[_unary__edvuaz];
    var _unary__edvuaz_0 = triePos;
    triePos = _unary__edvuaz_0 + 1 | 0;
    var possiblePrefixIndex = trie[_unary__edvuaz_0];
    if (!(possiblePrefixIndex === -1)) {
      prefixIndex = possiblePrefixIndex;
    }
    var nextStep;
    if (s == null) {
      break navigateTrie;
    } else if (scanOrSelect < 0) {
      var scanByteCount = imul(-1, scanOrSelect);
      var trieLimit = triePos + scanByteCount | 0;
      $l$loop: while (true) {
        var tmp_0 = data;
        var _unary__edvuaz_1 = pos;
        pos = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'okio.and' call
        var byte = tmp_0[_unary__edvuaz_1] & 255;
        var _unary__edvuaz_2 = triePos;
        triePos = _unary__edvuaz_2 + 1 | 0;
        if (!(byte === trie[_unary__edvuaz_2]))
          return prefixIndex;
        var scanComplete = triePos === trieLimit;
        if (pos === limit) {
          s = ensureNotNull(ensureNotNull(s).next_1);
          pos = s.pos_1;
          data = s.data_1;
          limit = s.limit_1;
          if (s === head) {
            if (!scanComplete)
              break navigateTrie;
            s = null;
          }
        }
        if (scanComplete) {
          nextStep = trie[triePos];
          break $l$loop;
        }
      }
    } else {
      var selectChoiceCount = scanOrSelect;
      var tmp_1 = data;
      var _unary__edvuaz_3 = pos;
      pos = _unary__edvuaz_3 + 1 | 0;
      // Inline function 'okio.and' call
      var byte_0 = tmp_1[_unary__edvuaz_3] & 255;
      var selectLimit = triePos + selectChoiceCount | 0;
      $l$loop_0: while (true) {
        if (triePos === selectLimit)
          return prefixIndex;
        if (byte_0 === trie[triePos]) {
          nextStep = trie[triePos + selectChoiceCount | 0];
          break $l$loop_0;
        }
        triePos = triePos + 1 | 0;
      }
      if (pos === limit) {
        s = ensureNotNull(s.next_1);
        pos = s.pos_1;
        data = s.data_1;
        limit = s.limit_1;
        if (s === head) {
          s = null;
        }
      }
    }
    if (nextStep >= 0)
      return nextStep;
    triePos = -nextStep | 0;
  }
  if (selectTruncated)
    return -2;
  return prefixIndex;
}
function rangeEquals(segment, segmentPos, bytes, bytesOffset, bytesLimit) {
  _init_properties_Buffer_kt__ndcom8();
  var segment_0 = segment;
  var segmentPos_0 = segmentPos;
  var segmentLimit = segment_0.limit_1;
  var data = segment_0.data_1;
  var i = bytesOffset;
  while (i < bytesLimit) {
    if (segmentPos_0 === segmentLimit) {
      segment_0 = ensureNotNull(segment_0.next_1);
      data = segment_0.data_1;
      segmentPos_0 = segment_0.pos_1;
      segmentLimit = segment_0.limit_1;
    }
    if (!(data[segmentPos_0] === bytes[i])) {
      return false;
    }
    segmentPos_0 = segmentPos_0 + 1 | 0;
    i = i + 1 | 0;
  }
  return true;
}
var properties_initialized_Buffer_kt_xv4xxe;
function _init_properties_Buffer_kt__ndcom8() {
  if (!properties_initialized_Buffer_kt_xv4xxe) {
    properties_initialized_Buffer_kt_xv4xxe = true;
    HEX_DIGIT_BYTES = asUtf8ToByteArray('0123456789abcdef');
    // Inline function 'kotlin.longArrayOf' call
    DigitCountToLargestValue = new BigInt64Array([-1n, 9n, 99n, 999n, 9999n, 99999n, 999999n, 9999999n, 99999999n, 999999999n, 9999999999n, 99999999999n, 999999999999n, 9999999999999n, 99999999999999n, 999999999999999n, 9999999999999999n, 99999999999999999n, 999999999999999999n, 9223372036854775807n]);
  }
}
//region block: exports
export {
  commonIndexOf as commonIndexOf2u7nnfp9zp5hz,
  readUtf8Line as readUtf8Line36yidw3sdfobh,
  selectPrefix as selectPrefix5tb3rl5iltlw,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
